import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {z as zod} from "zod";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

export type User = {
    additionalColumnValues: Record<Uuid, unknown>;
    createdAt: Iso8601DateTime;
    createdBy: Uuid;
    id: Uuid;
    /**
     * Parent platform user ID (`workspace_users.user_id`), not the workspace user row ID.
     */
    parentId: Uuid | null;
    status: UserStatus;
    templateId: Uuid;
    updatedAt: Iso8601DateTime;
    updatedBy: Uuid;
    userId: Uuid;
    workspaceId: Uuid;
};

export enum UserStatus {
    active = "b72ba7a7-2eab-4130-b0d2-1c29f4f7f556",
    deleted = "d94dc9c9-4fcd-6352-d2f4-3e51f6f9f778",
    // deprecated_active = "6a7f00b0-62f4-4631-b9b1-6ed97951828d",
    // deprecated_inactive = "2a3d873e-d8f8-4539-9fd0-e9d6cc27b366",
    inactive = "c83cb8b8-3fbc-5241-c1e3-2d40f5f8f667",
    pending = "302c5521-3b31-422b-8391-0f21a39dcf52",
    rejected = "5a0c32f7-69dc-4ad2-aa46-c0bb77f41683",
    suspended = "3adb9345-19f1-4126-9124-eeed6c3f9d9b",
};

export const userValidator: zod.ZodType<User> = zod.object({
    additionalColumnValues: zod.record(zod.string(), zod.unknown()),
    createdAt: iso8601DateTimeZodValidator,
    createdBy: uuidZodValidator,
    id: uuidZodValidator,
    parentId: uuidZodValidator.nullable(),
    status: zod.enum(UserStatus),
    templateId: uuidZodValidator,
    updatedAt: iso8601DateTimeZodValidator,
    updatedBy: uuidZodValidator,
    userId: uuidZodValidator,
    workspaceId: uuidZodValidator,
});
